import { Editor, Path, Range, Transforms } from 'slate';
import {
  type EditorPlugin,
  type MarkdownConvertOptions,
  type MarkdownRevertOptions,
} from '../../types/aha-editor';
import BlockUtils from '../Blocks/BlockUtils';
import MarkdownPlugin from '../MarkdownPlugin/MarkdownPlugin';
import CodeBlockComponentPlugin from './CodeBlockComponentPlugin';
import { EditorUtils } from '../../serialization';

const CodeBlockMarkdownPlugin: EditorPlugin = {
  name: 'Code Block Markdown plugin',
  dependencies: [MarkdownPlugin, CodeBlockComponentPlugin],
  markdown: [
    {
      type: 'element',
      regex: /(?:^|[^`])(```)$/,
      triggerCharacter: '`',
      convert: (editor: Editor, options: MarkdownConvertOptions) => {
        const { selection } = editor;
        if (!selection || !Range.isCollapsed(selection)) return false;

        const { startOfBlock, endOfBlock, blockEntry } = options;

        if (!blockEntry) return false;

        if (!startOfBlock) {
          if (endOfBlock) {
            const nextPath = Path.next(blockEntry[1]);
            Transforms.insertNodes(editor, EditorUtils.emptyParagraph(), {
              at: nextPath,
            });
            Transforms.select(editor, Editor.start(editor, nextPath));
          } else {
            Transforms.splitNodes(editor, { at: selection });
          }
        }

        BlockUtils.toggleBlock(editor, 'code');

        return true;
      },
      revert: (editor: Editor, options: MarkdownRevertOptions) => {
        const { selection } = editor;
        if (!selection || !Range.isCollapsed(selection)) return false;

        if (options.startOfBlock) {
          BlockUtils.wrapBlocks(
            editor,
            options.previousBlockType || 'paragraph'
          );
        } else {
          BlockUtils.wrapBlocks(
            editor,
            options.previousBlockType || 'paragraph'
          );
          Transforms.mergeNodes(editor, { at: selection.anchor });
        }

        return true;
      },
    },
  ],
};

export default CodeBlockMarkdownPlugin;
